import { ROUTE_LOADER_KIND } from './routeLoader.constants';

/**
 * Which vertical loader to show while a lazy route chunk downloads.
 * @returns {{ kind: string, fullHeight: boolean }}
 */
export function pickRouteLoader(pathname, savedActiveForm) {
  const path = pathname || '';

  if (path.includes('/train') || path.includes('/pnr-status')) {
    return { kind: ROUTE_LOADER_KIND.TRAIN, fullHeight: true };
  }
  if (path.startsWith('/flights/')) {
    return { kind: ROUTE_LOADER_KIND.FLIGHT, fullHeight: true };
  }
  if (path.includes('/flight')) {
    return { kind: ROUTE_LOADER_KIND.FLIGHT, fullHeight: false };
  }
  if (path.includes('/hotel')) {
    return { kind: ROUTE_LOADER_KIND.HOTEL, fullHeight: true };
  }
  if (savedActiveForm === 'train') {
    return { kind: ROUTE_LOADER_KIND.TRAIN, fullHeight: true };
  }
  if (savedActiveForm === 'hotel') {
    return { kind: ROUTE_LOADER_KIND.HOTEL, fullHeight: true };
  }
  return { kind: ROUTE_LOADER_KIND.FLIGHT, fullHeight: false };
}
